<template>
  <div class="page">
    <el-row>
      <div class="logo">
        <img src="../assets/logo1.png" width="200" alt="" />
      </div>
      <el-col :span="8" :offset="8">
        <div class="login-form">
          <div class="header">
            <span>分享给我的订单组</span>
          </div>
          <div class="content">
            <p class="tips">请输入查看订单组密码</p>
            <el-form :model="form" class="login">
              <el-form-item>
                <el-input v-model="form.pass"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button round type="primary" @click="login">确定</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<style lang="less" scoped>
.page {
  margin-top: 80px;
}

.logo {
  margin-bottom: 50px;
  text-align: center;
}

.login-form {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;

  .header {
    padding: 20px;
    border-radius: 4px 4px 0 0;
  }

  .content {
    padding: 20px;
  }
}

.header {
  background: #409eff;
  color: #fff;
}

.tips {
  color: #909399;
  font-size: 14px;
}

.login {
  width: 100%;
}
</style>

<script>
import request from "@/util/request"
import { Message } from "element-ui"
export default {
  name: "login",
  data() {
    return {
      form: { pass: "", code: this.$route.params.enCode },
      groupId: ""
    }
  },
  methods: {
    login() {
      let groupId = ""
      request({
        url: "/gengfu/user/validShareGroup",
        data: this.form,
        method: "POST"
      })
        .then(res => {
          groupId = res
          this.$router.push({ name: "dashboard", query: { groupId } })
        })
        .catch(res => {
          Message({
            type: "error",
            message: res.message,
            duration: 3 * 1000
          })
        })
    }
  }
}
</script>
